module.exports = __webpack_public_path__ + "img/slika_421.a4e0b790.jpeg";